import ComponentImage from "GeneralComponents/ComponentImage";
import BannerItem from "../Banner.interface";
import Consts from "Interfaces/Consts";
import "./BannersWithLinks.css";

type Props = {
    bannerItem: BannerItem;
    cancelVideoLoop: boolean;
    onVideoEnded: () => void;
}

function getLinkAttributes(bannerItem: BannerItem) {
    if (bannerItem.url) {
        return {
            href: bannerItem.url,
            target: "_blank",
            title: Consts.openInNewWindow
        };
    } else if (bannerItem.link?.url) {
        const { target, title, url } = bannerItem.link;
        return {
            href: url,
            target: target || "",
            title: title ? `${title} ${target? Consts.openInNewWindow: ''}` : ""
        };
    }
    return { href: "", target: "", title: "" };
};

const BannersWithLinksItem: React.FC<Props> = ({ bannerItem, cancelVideoLoop, onVideoEnded }) => {

    const linkAttrs = getLinkAttributes(bannerItem);


    return (
        <div className={`d-lg-flex flex-row mst-Banner-Content mst-BannersWithLinks-Content`}>
            {(bannerItem.url.trim() !== "" || bannerItem.link.url.trim() !== "") && (
                <a {...linkAttrs} className="w-100">
                    {bannerItem.imageOrMovie.url && (
                        <ComponentImage
                            image={bannerItem.imageOrMovie}
                            imageClass="img-fluid"
                            mobileImage={bannerItem.mobileImageOrMovie}
                            mobileImageClass="img-fluid"
                            wrapperDivClass="mst-Banner-Image"
                            cancelVideoLoop={cancelVideoLoop}
                            onVideoEnded={onVideoEnded}
                        />
                    )}
                </a>
            )}

            {(bannerItem.url.trim() === "" && bannerItem.link.url.trim() === "") && (
                <ComponentImage
                    image={bannerItem.imageOrMovie}
                    imageClass="img-fluid"
                    mobileImage={bannerItem.mobileImageOrMovie}
                    mobileImageClass="img-fluid"
                    wrapperDivClass="mst-Banner-Image"
                    cancelVideoLoop={cancelVideoLoop}
                    onVideoEnded={onVideoEnded}
                />
            )}
        </div>
    );
};

export default BannersWithLinksItem;
